import axios from '../index';

// TODO Reuse document reference api 'src/services/api/request/documentReference.js'
export const requestGetTachyReport = ({ id, author, isDoctor, isResearcher }) =>
  axios.get(`/fhir/DocumentReference`, {
    params: {
      subject: id,
      type: 'tachy',
      _count: 1,
      _elements: 'subject',
      ...((isDoctor || isResearcher) && { author }),
    },
  });

export const requestObservationHistory = ({
  status,
  desc,
  sort,
  count,
  patientId,
  pagesOffset,
  performer,
}) =>
  axios.get('/fhir/Observation', {
    params: {
      code: 'patient_report',
      subject: patientId,
      _count: count,
      _getpagesoffset: pagesOffset,
      [`_sort${desc ? ':desc' : ':asc'}`]: sort,
      status,
      performer,
    },
  });

export const requestReportItem = ({ id }) => axios.get(`/fhir/Observation/${id}`);

export const requestReportAttachment = ({ url }) => axios.get(`/fhir/${url}`);

export const requestCardiovascularReports = ({
  subject,
  count,
  pagesOffset,
  sort,
  type,
  desc,
  userId,
}) =>
  axios.get(`/fhir/DocumentReference`, {
    params: {
      _elements: 'type,extension',
      subject,
      type,
      _getpagesoffset: pagesOffset,
      _total: 'accurate',
      _count: count,
      author: userId,
      [`_sort${desc ? ':desc' : ':asc'}`]: sort,
    },
  });

export const requestPatientsObservationsStatuses = ({
  elements,
  patientsIds,
  status,
  count,
  performer,
}) =>
  axios.get(`/fhir/Observation`, {
    params: {
      _elements: elements,
      subject: patientsIds,
      status,
      _count: count,
      performer,
    },
  });
